'use client';

import {PropsWithChildren} from 'react';

import {useLocale} from '@utils/hooks/useLocale';

export default function HtmlLangLayout({children}: PropsWithChildren) {
  const lang = useLocale();

  return <html lang={lang}>{children}</html>;
}
